import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { currentUser } = useAuth();

  // Check if user is not logged in
  if (!currentUser) {
    return <Navigate to="/" replace />;
  }

  // Check if user is not active (is_active is false)
  if (currentUser.is_active === false) {
    return <Navigate to="/waiting-approval" replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
